module.exports = __webpack_public_path__ + "img/test.7f5f466c.jpg";